<template>
  <div class="apple-toplists" :aria-busy="String(loading)">
    <div v-if="official.length" class="apple-chart-grid">
      <article v-for="item in official" :key="item.id" class="apple-chart-card">
        <div class="apple-chart-banner"><Cover ref="chartCovers" :id="item.id" :label="item.name" type="playlist" :image-url="item.coverImgUrl || item.picUrl || fallback" :cover-hover="false" :always-show-play-button="false" :radius="7" /><h2 :title="item.name"><span class="apple-chart-title">{{ item.name }}</span></h2><button type="button" class="apple-chart-play" :aria-label="'播放' + item.name" :disabled="playingChart === String(item.id)" @click="playChart(item)"><svg-icon icon-class="play" /></button></div>
        <ol v-if="item.tracks && item.tracks.length" class="apple-chart-tracks"><li v-for="(song,index) in item.tracks.slice(0,3)" :key="index"><span class="apple-chart-rank">{{ index + 1 }}</span><span class="apple-chart-song" :title="song.first || song.name">{{ song.first || song.name }}</span><small :title="song.second || ''">{{ song.second || '' }}</small></li></ol>
        <router-link v-else class="apple-chart-empty" :to="{name:'playlist',params:{id:String(item.id)}}" :title="item.description || '打开榜单查看歌曲'"><span>{{ item.description || '打开榜单查看歌曲' }}</span></router-link>
      </article>
    </div>
    <section v-if="selected.length" class="apple-chart-other" :aria-label="official.length ? '官方榜单' : '排行榜'">
      <AppleSectionHeader :title="official.length ? '官方榜单' : '排行榜'" />
      <div class="apple-chart-other-grid">
        <article v-for="item in selected" :key="item.id" class="apple-chart-other-card">
          <div class="apple-chart-other-artwork"><Cover :id="item.id" :label="item.name" type="playlist" :image-url="item.coverImgUrl || item.picUrl || fallback" :cover-hover="false" :radius="6" /></div>
          <router-link class="apple-chart-other-title" :to="{name:'playlist',params:{id:String(item.id)}}" :title="item.name">{{ item.name }}</router-link>
          <span v-if="chartAudience(item)" class="apple-chart-audience">{{ chartAudience(item) }}</span>
        </article>
      </div>
    </section>
    <AppleState :loading="loading" :error="error" :count="items.length" empty-text="来源暂未返回排行榜。" @retry="loadFeed(false)" />
  </div>
</template>
<script>
import DiscoverToplists from '../salt/online/DiscoverToplists.vue';
import Cover from '../components/Cover.vue';
import AppleSectionHeader from './ui/AppleSectionHeader.vue';
import AppleState from './ui/AppleState.vue';
import './apple-discover-toplists.scss';
export default {
  name: 'AppleDiscoverToplists', extends: DiscoverToplists,
  components: { Cover, AppleSectionHeader, AppleState },
  data() { return { playingChart: '' }; },
  methods: {
    chartAudience(item) {
      for (const [field,label] of [['subscribedCount','收藏'],['playCount','播放']]) {
        const raw=item[field];
        if (!['string','number'].includes(typeof raw) || typeof raw === 'string' && !raw.trim()) continue;
        const value=Number(raw);
        if (Number.isFinite(value) && value >= 0) return `${label} ${value >= 100000000 ? (value / 100000000).toFixed(1) + '亿' : value >= 10000 ? (value / 10000).toFixed(1) + '万' : Math.floor(value)}`;
      }
      return '';
    },
    async playChart(item) {
      const id = String(item.id), cover = (this.$refs.chartCovers || []).find(component => String(component.id) === id);
      if (!cover) return;
      this.playingChart = id;
      try { await cover.play(); } finally { if (this.playingChart === id) this.playingChart = ''; }
    },
  },
};
</script>
